import { WidgetType } from 'domain/entity/widget';
import { WidgetDataTypes } from 'domain/entity/widgetData';

export type Timeseries = {
    timeseries: Timeserie[];
};

export type TimeValue = { t: Date; v: number };
export type TimeserieMetadata = {
    units: string;
    name: string;
    from: Date;
    to: Date;
    timezone: string;
};
export type Timeserie = { id: string; timeValues: TimeValue[]; metadata: TimeserieMetadata };

export const isTimeSeries = (obj: WidgetDataTypes | TimeseriesData): obj is TimeseriesData => obj.type === WidgetType.TIMESERIES;
class TimeseriesData implements Timeseries {
    type = WidgetType.TIMESERIES;

    constructor(readonly timeseries: Timeserie[]) {}
}

export default TimeseriesData;
